import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function LockedPage({ featureName, children }) {
  const navigate = useNavigate();
  return (
    <div style={{ position: 'relative', height: '100%', overflow: 'hidden' }}>

      {/* Real page content — visible but non-interactive */}
      <div style={{ height: '100%', pointerEvents: 'none', userSelect: 'none' }}>
        {children}
      </div>

      {/* Frosted overlay */}
      <div style={{
        position: 'absolute', inset: 0,
        backdropFilter: 'blur(3px)',
        WebkitBackdropFilter: 'blur(3px)',
        background: 'rgba(var(--bg-page-rgb, 248,250,252), 0.55)',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        zIndex: 10,
      }}>
        <div style={{
          background: 'var(--color-surface, #fff)',
          border: '1px solid var(--color-border, #e2e8f0)',
          borderRadius: 12,
          padding: '28px 32px',
          maxWidth: 360,
          width: '90%',
          textAlign: 'center',
          boxShadow: '0 8px 32px rgba(0,0,0,0.10)',
        }}>
          <div style={{
            width: 44, height: 44, borderRadius: '50%',
            background: 'var(--color-border, #f1f5f9)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 14px',
          }}>
            <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ color: 'var(--color-text-secondary, #64748b)' }}>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <p style={{ fontSize: 15, fontWeight: 600, color: 'var(--color-text-primary, #0f172a)', margin: '0 0 6px' }}>
            {featureName}
          </p>
          <p style={{ fontSize: 13, color: 'var(--color-text-secondary, #64748b)', margin: '0 0 20px', lineHeight: 1.5 }}>
            Beschikbaar in het Bureau abonnement (€89/mnd). Upgrade om volledige toegang te krijgen.
          </p>
          <button
            onClick={() => navigate('/account')}
            style={{
              fontSize: 13, fontWeight: 600,
              background: 'var(--brand, #1e3a5f)', color: '#fff',
              border: 'none', borderRadius: 8, padding: '8px 20px',
              cursor: 'pointer', width: '100%',
            }}
          >
            Upgraden naar Bureau
          </button>
        </div>
      </div>
    </div>
  );
}
